<template>
    <div :class="this.index + 'container p-2'">
        <div :class="[selected ? 'option selected' : 'option ', rec ? 'recommended' : '']">

            <form v-on:submit.prevent="submit_plan">

                <div class="row p-3">
                    <div class="position-relative">
                        <img class="col-12 px-4 meal" :src="mealImage">
                        <div class="already-subscribed-div">
                            <label class="already-subscribed mb-3" v-if="already_subscribed"><em>Subscribed</em></label>
                        </div>
                    </div>

                    <div class="info" v-on:click="show_meals"
                          v-tooltip="startDate ? 'Look at this plans meals' : 'Please select a start week to preview meals' ">
                        <icon fill="currentColor" name="eye" :class="selected ? 'selected-icon icon' : 'icon'" v-if="!loadingMeals"></icon>
                        <loading-spinner v-if="loadingMeals"/>
                    </div>

                    <div class="info-2" data-toggle="tooltip" data-placement="top" title="Click Here to View This Plans Meals">
                        <p class="rec-text" v-if="rec">* Recommended</p>
                    </div>

                    <div class="col-12 text-center mt-2 p-0">
                        <h2 :class="selected ? 'selected-name plan' : 'plan'">{{plans ? plans[0].name : ''}}</h2>
                    </div>

                    <div class="col-12 text-center">
                        <div class="dropdown mt-2">
                            <button type="button"
                                      :class="selected ? 'btn btn-outline-primary dropdown-toggle col-12 selected-2' : 'btn btn-outline-primary dropdown-toggle col-12' "
                                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{this.filter_meal_count(this.plan ? this.plan.mealCount : '')}}
                            </button>
                            <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton2">
                                <a
                                    :id="'button-'+index+'-0'"
                                    :class="selectedId === 0 ? 'btn-primary dropdown-item' : 'btn-outline-primary dropdown-item'"
                                    v-on:click.prevent="set_selected_meal_plan(plans[0], 0)">Full Week (21 Meals)
                                </a>
                                <a
                                    :id="'button-'+index+'-0'"
                                    :class="selectedId === 0 ? 'btn-primary dropdown-item' : 'btn-outline-primary dropdown-item'"
                                    v-on:click.prevent="set_selected_meal_plan(plans[1], 1)">First Part of Week (12 Meals)
                                </a>
                                <a
                                    :id="'button-'+index+'-0'"
                                    :class="selectedId === 0 ? 'btn-primary dropdown-item' : 'btn-outline-primary dropdown-item'"
                                    v-on:click.prevent="set_selected_meal_plan(plans[2], 2)">Second Half of Week (9 Meals)
                                </a>
                            </div>
                        </div>
                    </div>

                    <div :id="'start-day' + (this.plan ? this.plan.name.substring(0,4) : '') "
                          :class="{ 'control': true, 'col-12 mt-2 text-center' : true }">
                        <date-picker :class="selected ? 'selected-2 hflm-date-picker' : 'hflm-date-picker' "
                                         :inputClass="'form-control hflm-purple ' + (this.plan ? this.plan.name.substring(0,4) : '') "
                                         :placeholder="startDate ? startDate.toString() : 'Select Start Week'"
                                         :disabled="disabled_"
                                         :open-date="open_calendar_date"
                                         v-model="startDate"/>

                    </div>
                    <div class="col-12 text-center">
                        <div class="dropdown mt-2">
                            <button type="button"
                                      :class="selected ? 'selected-2 btn btn-outline-primary dropdown-toggle col-12' : 'btn btn-outline-primary dropdown-toggle col-12'"
                                      :id="'weeks'+(this.plan ? this.plan.name.substring(0,4) : '')"
                                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{subscribe ? 'Subscribed' : !weeks ? 'Number of Weeks' : weeks + ' Weeks'}}
                            </button>
                            <div class="dropdown-menu w-100" aria-labelledby="dropdownButton">
                                <a class="dropdown-item" v-for="(i,index) in 4" :key='index' v-on:click="set_weeks(i)">{{i}}</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mt-3 text-center">

                        <p class="sub" v-on:click="show_sub_desc">Would you like to subscribe?</p>

                        <div class="pretty p-icon p-curve p-rotate">
                            <input type="checkbox" class="ml-2" v-model="subscribe"/>
                            <div class="state">
                                <label>Subscribe</label>
                                <icon fill="currentColor" class="icon mdi mdi-check" name="heart"></icon>
                            </div>
                        </div>

                    </div>

                    <div class="col-12 mt-3 text-center" v-if="allow_no_fish_selection">

                        <p class="sub" v-on:click="show_sub_desc" v-if="noFishPlan">This plan has no fish meals.</p>
                        <p class="sub" v-on:click="show_sub_desc" v-else>Do you have a fish preference?</p>

                        <div class="pretty p-icon p-curve p-rotate">
                            <input type="checkbox" class="ml-2" :disabled="noFishPlan" v-model="noFish"/>
                            <div class="state">
                                <label>No Fish</label>
                                <icon fill="currentColor" class="icon mdi mdi-check" name="check"></icon>
                            </div>
                        </div>

                        <p class="font-italic mb-0" v-if="past_customization_date && noFish">The first delivery will have fish since it is past the customization deadline.</p>

                    </div>

                    <div class="col-12 mt-3 text-center" v-else>
                        <!--Does this just need to say, this plan may have fish in it?-->
                        <p class="sub"
                            v-on:click="show_sub_desc">
                            <span v-if="meal_plan_info.nameShort !== '1500'">This plan has one meal with fish in it each week</span>
                            <span v-else>This plan has no fish meals</span>
                        </p>
                        <p class="font-italic mb-1">Past Customization Deadline.</p>
                    </div>

                    <div class="col-12">
                        <hr/>
                    </div>

                    <div class="col-12 mt-2 text-center" v-if="plan">
                        <p>
                            <span class="font-italic">{{plan.mealCount}} meals per week.</span><br/>
                            <template v-if="delivery_offset != null">
                                <h3><strong>Pickup or Delivery on {{delivery_offset.format('MMMM D')}}</strong></h3>
                            </template>
                            <template v-else-if="plan.mealCount === 21">
                                <span class="font-italic">Monday and Thursday Pickup or Delivery.</span>
                            </template>
                            <template v-else-if="plan.mealCount === 12">
                                <span class="font-italic">Monday Pickup or Delivery.</span>
                            </template>
                            <template v-else-if="plan.mealCount === 9">
                                <span class="font-italic">Thursday Pickup or Delivery.</span>
                            </template>
                        </p>
                    </div>

                    <div class="col-12">
                        <hr/>
                    </div>

                    <div class="col-12 text-center" v-if="plan">
                        <h1 :class="this.plan.name.substring(0,4) + '-cost'">
                            $ {{subscribe ? animatedCost.toLocaleString() + ' a week' : animatedCost.toLocaleString()}}
                        </h1>
                    </div>

                    <div class="col-12">
                        <hr/>
                    </div>

                    <div class="col-12">
                        <button :id="'button-'+index+'-select'"
                                  :class="selected ? 'btn-outline-primary font-bold selected-2 btn w-100' :
                    'btn-outline-primary btn w-100'">Next: Delivery/Pickup
                        </button>
                    </div>

                </div>

            </form>

        </div>
        <already-ordered-modal :activeOrderItems="active_order_items" :startDate="startDate" :index="index"/>
        <notification-modal :notifications="notifications" :startDate="startDate" :index="index"/>
        <preview-meals-modal  :meals="meals" :plan="plan" :deliveryDate="startDate" :noFish="noFish" :index="index"/>
    </div>
</template>

<script>
    import DatePicker from 'vuejs-datepicker'
    import moment from 'moment'
    import {get_delivery_offset, get_next_order_cutoff_datetime, get_order_cutoff_datetime} from '../../helpers/helpers'
    import AlreadyOrderedModal from '../Globals/AlreadyOrderedModal'
    import PreviewMealsModal from './PreviewMealsModal'
    import LoadingSpinner from '../Globals/LoadingSpinner'
    import NotificationModal from '../Globals/NotificationModal'
    
    const $ = window.$    

    const TWEEN = require('@tweenjs/tween.js')

    export default {
        name: 'order-guide-plan',
        props: ['plans', 'index', 'selected', 'mealImage'],
        components: {
            LoadingSpinner,
            DatePicker,
            AlreadyOrderedModal,
            PreviewMealsModal,
            NotificationModal
        },
        data() {
            return {
                meals: null,
                subscribe: false,
                already_subscribed: false,
                rec: false,
                selectedId: 0,
                plan: null,
                recent: false,
                start_day_error: '',
                zip: '',
                startDate: null,
                recurring_view: false,
                recurring_order: false,
                weeks: null,
                cost: 0,
                animatedCost: 0,
                noFish: false,
                loadingMeals: false,
                notifications: undefined,
                displayPreviewMealsModal: false,
            };
        },
        watch: {
            startDate: function () {
                let notifications = this.checkForNotifications(this.startDate);
                this.notifications = notifications;
                if (this.active_order_on_start_date) {
                    $('#alreadyOrderedModal-' + this.index).modal();
                } else {
                    if (!this.startDate) {
                        $('#start-day' + this.plan.name.substring(0, 4) + ' input').removeClass('is-danger no-border');
                    }
                    this.emitSelectedPlan();
                }

                if (this.active_order_on_start_date) {
                    const context = this;
                    $('#alreadyOrderedModal-' + this.index).on('hidden.bs.modal', function () {
                        if (context.startDate && notifications.length > 0) {
                            // console.log(this.startDate)
                            $('#notificationModal-' + context.index).modal();
                        }
                    });
                } else if (this.startDate) {
                    if (notifications.length > 0) {
                        $('#notificationModal-' + this.index).modal();
                    }
                }
            },
            plan: function () {
                this.startDate = null;
            },
            subscribe: function () {
                if (this.subscribe) {
                    this.weeks = 1;
                    setTimeout(() => {
                        this.subscribe = true;
                    }, 50);
                }
                this.emitSelectedPlan();
            },
            weeks: function () {
                if (this.subscribe) {
                    this.subscribe = false;
                    this.cost = this.plan.cost * (this.weeks ? this.weeks : 1);
                }
                if (this.weeks) {
                    $('#weeks' + this.plan.name.substring(0, 4)).removeClass('is-danger no-border');
                }
            },
            cost: function (newValue, oldValue) {
                var self = this;

                function animate() {
                    if (TWEEN.update()) {
                        requestAnimationFrame(animate);
                    }
                }

                new TWEEN.Tween({tweeningNumber: oldValue})
                .easing(TWEEN.Easing.Quadratic.Out)
                .to({tweeningNumber: newValue}, 1000)
                .onUpdate(function () {
                    self.animatedCost = this.tweeningNumber.toFixed(0);
                })
                .start();
                animate();
            }
        },
        computed: {
            active_order_items() {
                return this.$store.getters.get_active_order_items;
            },
            active_order_dates() {
                return this.active_order_items.map(item => moment(item.deliveryDate).format('YYYY-MM-DD'));
            },
            active_order_on_start_date() {
                if (this.startDate) {
                    if (this.active_order_dates.includes(moment(this.startDate).format('YYYY-MM-DD'))) {
                        return true;
                    }
                }
                return false;
            },
            delivery_offset() {
                return get_delivery_offset(this.startDate, this.delivery_offsets);
            },
            delivery_offsets() {
                return this.$store.getters.get_delivery_offsets;
            },
            meal_plan_info() {
                if (this.plans && this.plans.length > 0) {
                    return this.$store.getters.get_meal_plan_infos.find(mpi => mpi.id === this.plans[0].mealPlanInfoId);
                }
                return null;
            },
            open_calendar_date() {
                let cutoff = get_next_order_cutoff_datetime(this.cutoffs, this.delivery_offsets, this.plan ? this.plan.pickupDay : 1, false);
                return moment(cutoff)
                // removing magic number because causing bug for end of Dec calendar --Tom
                // .add(3, 'd')
                .format('MMMM DD YYYY');
            },
            cutoffs() {
                return this.$store.getters.get_cutoffs;
            },
            order() {
                return this.$store.getters.get_order;
            },
            disabled_() {
                if (!this.plan) {
                    return {
                        to: new Date(),
                        days: [0, 1, 2, 3, 4, 5, 6]
                    };
                }
                return {
                    to: this.check_date(),
                    days: [0, 1, 2, 3, 4, 5, 6].filter(d => d !== this.plan.pickupDay)
                };
            },
            user() {
                return this.$store.getters.user;
            },
            noFishPlan() {
                return this.meal_plan_info && this.meal_plan_info.noFish === 1;
            },
            past_customization_date() {
                if (this.startDate) {
                    let deliveryDate = moment(this.startDate);
                    let cutoff = get_order_cutoff_datetime(this.cutoffs, this.delivery_offsets, deliveryDate, true, false);
                    if (moment(cutoff).isBefore(moment())) {
                        return true;
                    }
                }
                return false;
            },
            allow_no_fish_selection() {
                return !this.past_customization_date || this.subscribe;
            }
        },
        methods: {
            checkForNotifications(date) {
                if (!date) {
                    return [];
                }
                return this.$store.getters.get_notifications.filter(n => {
                    const start = moment(n.startShowing).startOf('d');
                    const end = moment(n.stopShowing).endOf('d');
                    const y = moment(date);
                    return y.isSameOrAfter(start) && y.isSameOrBefore(end) && n.showMenu;
                });
            },
            get_meals(deliveryDate, mealPlanId) {
                this.loadingMeals = true;
                let weekOfYear = moment(deliveryDate).week();
                let year = moment(deliveryDate).endOf('week').year();
                let payload = {
                    mealPlanId: mealPlanId,
                    year: year,
                    week: weekOfYear
                };
                this.$store.dispatch('get_plan_meals', payload).then(result => {
                    let days = [1, 2, 3, 4];
                    if (moment(deliveryDate).day() === 4) {
                        days = [5, 6, 7];
                    }
                    this.meals = result.meals.sort((a, b) => {
                        if (a.suggestedDay < b.suggestedDay) {
                            return -1;
                        } else if (a.suggestedDay > b.suggestedDay) {
                            return 1;
                        } else if (a.mealTime < b.mealTime) {
                            return -1;
                        } else if (a.mealTime > b.mealTime) {
                            return 1;
                        }
                        return 0;
                    });
                    if (this.selectedId !== 0) {
                        // If selectedId === 0, then, show all 21 meals.
                        this.meals.filter(meal => days.includes(meal.suggestedDay));
                    }
                    this.loadingMeals = false;
                    $('#PreviewMealsModal' + this.plans[0].name.split(' ')[0]).modal('show');
                });
            },
            show_meals() {
                this.meals = null;
                if (this.startDate) {
                    this.get_meals(this.startDate, this.plan.id);
                }
            },
            show_sub_desc() {
                $('html, body').animate({
                    scrollTop: $('#about-sub').offset().top
                }, 2000);
                setTimeout(() => {
                    $('#about-sub').addClass('highlight');
                }, 500);
            },
            calc_menu() {
                let plan = this.plan ? this.plan.name.split(' ')[2] : '';
                switch (plan) {
                    case 'Traditional':
                        return 'traditional-menu';
                    default:
                        return 'vegetarian-menu';
                }
            },
            filter_meal_count(meal) {
                switch (meal) {
                    case 21:
                        return 'Full Week (21 Meals)';
                    case 12:
                        return 'First Half of Week (12 Meals)';
                    case 9:
                        return 'Second Half of Week (9 Meals)';
                    default:
                        return '';
                }
            },
            set_weeks(weeks) {
                this.weeks = weeks;
                $('h1.' + this.plan.name.substring(0, 4) + '-cost').addClass('animating');
                this.cost = this.plan.cost * weeks;
                setTimeout(() => {
                    $('h1.' + this.plan.name.substring(0, 4) + '-cost').removeClass('animating');
                }, 1000);
                this.emitSelectedPlan();
            },
            check_date() {
                return get_next_order_cutoff_datetime(this.cutoffs, this.delivery_offsets, this.plan ? this.plan.pickupDay : 1, false);
            },
            emitSelectedPlan() {
                this.$emit('plan-selected', {
                    plan: this.plan,
                    index: this.index
                })
            },
            set_selected_meal_plan(meal_plan, id, emit = true) {
                this.plan = meal_plan;
                this.selectedId = id;
                if (emit) {
                    this.$emit('plan-selected', {
                        plan: meal_plan,
                        index: this.index
                    });
                }
                $('h1.' + this.plan.name.substring(0, 4) + '-cost').addClass('animating');
                this.cost = meal_plan.cost * this.weeks;
                setTimeout(() => {
                    $('h1.' + this.plan.name.substring(0, 4) + '-cost').removeClass('animating');
                }, 1000);
            },
            submit_plan() {
                if (!this.startDate || !this.weeks) {
                    if (!this.startDate) {
                        $('#start-day' + this.plan.name.substring(0, 4) + ' input').addClass('is-danger');
                    }
                    if (!this.weeks) {
                        $('#weeks' + this.plan.name.substring(0, 4)).addClass('is-danger');
                    }
                } else {
                    let noFish = this.noFish && !this.past_customization_date;
                    let order = {
                        startDate: this.startDate,
                        weeks: this.subscribe ? 1 : this.weeks,
                        subscribe: this.subscribe,
                        noFish: noFish
                    };
                    this.$store
                    .dispatch('add_to_order_meal_plan', {
                        mealPlan: this.plan,
                        order: order
                    })
                    .then( () => {
                        this.$router.push('/orders/pickup-or-delivery');
                    });
                }
            }
        },
        mounted() {
            this.$eventHub.$on('cancel-set-date', () => {
                this.startDate = null;
            });
            this.plan = this.plans[0]
            if (this.$route.query.rec === this.plans[0].nameShort) {
                this.rec = true;
                // this.$eventHub.$emit('meal-rec', this.plans[0].nameShort);
                this.emitSelectedPlan();
            }
            if (this.order && this.order.mealPlan) {
                let found = this.plans.find(plan => this.order.mealPlan.id === plan.id);
                if (found) {
                    this.set_selected_meal_plan(found, this.plans.indexOf(found), true);
                    this.weeks = this.order.order.weeks;
                    this.subscribe = this.order.order.subscribe;
                    this.cost = found.cost * this.weeks;
                } else {
                    this.set_selected_meal_plan(this.plans[0], 0, false);
                    this.cost = this.plans[0].cost * (this.weeks ? this.weeks : 1);
                }
            } else {
                this.set_selected_meal_plan(this.plans[0], 0, this.index == 0);
                this.cost = this.plans[0].cost * (this.weeks ? this.weeks : 1);
            }
            if (this.$store.getters.get_user_subscriptions) {
                let subs = this.$store.getters.get_user_subscriptions
                .filter(y => y.status === 1)
                .map(x => x.mealPlan.id);
                let plans = this.plans.map(x => x.id);
                subs.filter(x => plans.includes(x)).map(x => {
                    if (plans.includes(x)) {
                        this.already_subscribed = true;
                    }
                });
            }
            this.subscribe = this.already_subscribed
            this.weeks = this.already_subscribed ? 1 : null
            if (this.user && this.user.preferences) {
                this.noFish = this.user.preferences.includes('NoFish');
            }
            // $('.info').tooltip();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../styles/scss/colors";

    .option {
        border: 1px solid $light-grey;
        border-radius: 5px;
    }

    .selected {
        box-shadow: 10px 10px 5px $purple-background-2;
    }

    .selected-2 {
        box-shadow: 3px 3px 3px $purple-background-2;
    }

    .recommended {
        border: 2px solid $purple;
    }

    .hflm-date-picker::placeholder {
        color: $purple !important;
    }

    a:hover {
        cursor: pointer;
    }

    [class^="-cost"] {
        transition: all 1s ease-out;
    }

    h1.animating {
        transition: all 2s ease-out;
        font-style: italic;
        color: $green !important;
    }

    .font-bold {
        font-weight: bold;
    }

    .btn:hover {
        font-weight: bold;
    }

    .meal {
        position: relative;
    }

    .icon {
        color: $grey;
        height: 25px;
        width: 25px;
        &:hover {
            cursor: pointer;
        }
    }

    .info {
        position: absolute;
        right: 50px;
        top: 35px;
    }

    .info-2 {
        position: absolute;
        left: 50px;
        top: 35px;
    }

    .selected-icon {
        color: $purple;
    }

    .recommended-icon {
        height: 25px;
        width: 25px;
        color: $purple;
    }

    .selected-name {
        font-style: italic;
        color: $purple;
    }

    .rec-text {
        font-weight: bold;
        position: relative;
        top: -38px;
        background: white;
        width: 190px;
        padding-left: 40px;
        color: $purple;
    }

    .divider {
        border: 0.5px solid $silver;
        width: 88%;
    }

    .or {
        text-align: center;
        position: relative;
        background: white;
        top: 5px;
        width: 45px;
    }

    #subscribe {
        position: relative;
        top: -1px;
    }

    .sub {
        color: $purple;
        font-style: italic;
        &:hover {
            cursor: pointer;
        }
    }

    button.no-border {
        border-color: $purple !important;
    }


    .already-subscribed {
        font-weight: bold;
        color: $purple-background-2;
        position: absolute;
        top: -20px;
        left: 12px;
    }

    .already-subscribed-div {
        position: absolute;
        top: 25%;
        transform: rotate(-30deg);
    }

    .calendar {
        color: $purple;
        margin-left: 10px;
    }

    .modal-open .modal {
        overflow-y: hidden;
    }

    .hflm-purple::placeholder {
        color: $purple !important;
    }

    .mdi-check {
        color: $purple !important;
    }

    .tooltip {
        z-index: 111;
    }
</style>
